import {TFunction} from 'i18next';
import {RowData} from '../../base/export-care-plan-group-data-processor';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonIadlPdfDataProcessor} from '../export-care-plan-common-iadl-pdf-data';

export class ShoppingPdfDataProcessor extends CommonIadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (rowData: RowData) => {
      // TODO: We should get by feature.
      const shoppingEntry = rowData.getEntryById('64ed45f253b81e23b761a38e');
      const shoppingName = `<b>${shoppingEntry?.name ?? 'n/a'}:</b>`;
      const shoppingValue = this.getEntryValue(shoppingEntry);

      return `${shoppingName}\n${shoppingValue}`;
    };
  }
}
